import { useMemo } from 'react';
import { Accordion } from '@/components/Accordion';
import { basicPlanPlansFaqItems } from '@/constants/plansFaq';
import { useTranslation } from 'react-i18next';

export default function PlansFaq() {
    const { t } = useTranslation('plans');

    const items = useMemo(
        () =>
            basicPlanPlansFaqItems.map((item) => ({
                title: t(item.titleKey),
                content: t(item.contentKey, { interpolation: { escapeValue: false } }),
            })),
        [t],
    );

    return (
        <div className="flex justify-center p-4 lg:p-20">
            <div className="w-full lg:w-3/4 max-w-4xl">
                <Accordion
                    items={items}
                    className="rounded-lg border-2 border-gray-300"
                    titleClassName="font-medium text-lg lg:text-xl p-4 border-b border-gray-300"
                    contentClassName="bg-gray-50 leading-loose tracking-widest p-5 text-md lg:text-lg"
                />
            </div>
        </div>
    );
}
